module.exports = __webpack_public_path__ + "img/production-two.66d3b4a8.png";